import { useContent } from "@/context/ContentContext";

export function VideoBackdrop({ opacity = 0.35, className = "" }) {
  const { content } = useContent();
  const media = content?.media || {};
  if (!media.store_video_url && !media.store_poster_url) return null;
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" data-testid="video-backdrop">
      {media.store_video_url ? (
        <video className="h-full w-full object-cover" style={{ opacity }} autoPlay muted loop playsInline preload="metadata" poster={media.store_poster_url || undefined}>
          <source src={media.store_video_url} />
        </video>
      ) : (
        <img src={media.store_poster_url} alt="" className="h-full w-full object-cover" style={{ opacity }} />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-eden-bg/40 via-eden-bg/70 to-eden-bg" />
    </div>
  );
}
